import '../.././App.less';
import { Layout,ConfigProvider,Table,Modal,Input, Space, AutoComplete,Select,Button } from 'antd';
import React, { Component } from "react";
import es_ES from 'antd/lib/locale/es_ES';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, UserOutlined,FileTextOutlined,CheckOutlined,StarOutlined,CalendarOutlined,TagsOutlined,AuditOutlined,QrcodeOutlined } from '@ant-design/icons';
import moment from 'moment'
import {getAuthors,getAuthorsStr,IP} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from '../components/AdminMenu';


class AdminLogs extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      plays:[],
      showPlayDetails:false,
      record:null,
      isBusy:true,
    }
  }
  async componentWillMount() {
    //Plays
    const response_plays = await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    })
    const json_plays = await response_plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    //Users
    const response_user= await fetch(IP + `api/casa/usuario/`,{
      method: "get",
      credentials: "same-origin"}
    )
    const json_user = await response_user.json();
    var user_dict = {}
    for(var i in json_user){
      var user = json_user[i]
      user_dict[user.id] = user
    }
    //Genre
    const genr = await fetch(IP + 'api/casa/genero/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    this.json_g = await genr.json();
    this.genres_dict = {};
    this.json_g.forEach(element => {
      this.genres_dict[element.id] = element.nombre
    });

    //Logs
    const logs = await fetch(IP + 'api/casa/logs/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_logs = await logs.json();
    
    
    var data = []
    var data_play = {}
    this.plays = new Set();
    this.dates = new Set();
    this.action = new Set();
    this.users = new Set();

    const Moment = require('moment');
    
    //Fill plays data
    for(var i in json_plays){
      var item = json_plays[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      const year = date.split('-')[2]
      var authorStr = getAuthorsStr(item.conc).join(", ")
      data_play[item.id]=
        { 
          id : i,
          title : item.titulo,
          author: author ,
          authorStr:authorStr,
          date:date,
          pseudo: item.pseudonimo,
          code:year+'_'+item.genero+'_'+item.id,
          conc:item.conc,
          category:this.genres_dict[item.genero],
          pdf:item.pdf,
          edit:'',
          qualified:item.califica,
          preselected:item.preseleccionada
        };
    };
    //Fill Logs data
    for(var i in json_logs){
      var log = json_logs[i]
      var date = new Moment(log.fecha).format('MMMM D YYYY, h:mm:ss a')
      this.dates.add(date)
      this.action.add(log.accion)
      this.users.add(user_dict[log.usuario].username)
      if(log.obra)//Check if log is about plays
        this.plays.add(data_play[log.obra].title)
      data.push({
        id:log.id,
        action:log.accion,
        userId:log.usuario,
        user:user_dict[log.usuario].username,
        userObj:user_dict[log.usuario],
        play:log.obra? data_play[log.obra].title :'',
        playObj:log.obra? data_play[log.obra] :null,
        date:date,
        unixDate: new Moment(log.fecha).unix(),
      })
    }

    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })
    this.action =[...this.action].map((v)=>{
      return {value:v}
    })
    this.users = [...this.users].map((v)=>{
      return {value:v}
    })
    this.plays = [...this.plays].map((v)=>{
      return {value:v}
    })
    this.setState({ plays: data, plays_report:data_play, filteredInfo: data, isBusy:false });
  }
  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "user"){
      return this.users
    }
    
      else if (dataIndex == "action" ) {
        return this.action
    } 

    else if (dataIndex== "play"){
      return this.plays
    }
    else{
      return this.dates
    }
  }
  
  getColumnSearchProps = (dataIndex,name) => dataIndex!='edit' && ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => ( dataIndex!='edit' &&
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
             <Input
               ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Buscar ${name}`}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() => this.handleReset(clearFilters)} size="small" type="reset" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>
          </div>
        ),
        filterIcon: filtered =>dataIndex!='edit' && <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
          if (visible && dataIndex!= 'edit') {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
          this.state.searchedColumn === dataIndex ? (
            <div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>
          ) : (
            <div  style={{fontSize:'large' }}>
            {(dataIndex=='play' && <a onClick={()=>this.setState({showPlayDetails:true,record:record.playObj})}>{text}</a>)||
            <div >  {text} </div>}
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
      };

  render() {
 
      const { Content } = Layout;
      const Moment = require('moment');
      const columns = [
        {
          title: <div style={{fontWeight:'bold', fontSize:'large' }}>Acción</div>,
          dataIndex: 'action',
          key: 'action',
          width:'20%',
          sorter: (a, b) => a.action.localeCompare(b.action),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnSearchProps('action','acción'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Usuario</div>,
          dataIndex: 'user',
          key: 'user',
          width:'7%',
          sorter: (a, b) => a.user.localeCompare(b.user),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnSearchProps('user','usuario'),
          responsive: ['sm'] 

        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Obra</div>,
          dataIndex: 'play',
          key: 'play',
          width:'10%',
          sorter:(a,b) => a.play.localeCompare(b.play),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnSearchProps('play','obra'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
          dataIndex: 'date',
          key: 'date',
          width:'10%',
          sorter:(a,b) =>moment.utc(a.unixDate).diff(moment.utc(b.unixDate)),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnSearchProps('date','fecha'),
          responsive: ['sm'] 
        },
      ];
    return (

      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <AdminMenu/>
              <Content>
                  <Table
                    loading={this.state.isBusy}
                    columns={columns}
                    bordered
                    dataSource= {this.state.plays}
                    pagination={{position: ["bottomCenter"]}}
                    tableLayout='fixed'
                    style={{ whiteSpace: 'normal'}}
                    size="medium"
                    onChange = {this.handleTableChange}
                  />
                { 
                  this.state.showPlayDetails && 
                  <Modal 
                    closable = {false}
                    title={ this.state.record.code}
                    visible={this.state.showPlayDetails} 
                    onCancel={()=>this.setState({record:null,showPlayDetails:false})}
                    footer={[
                      <Button key="back" onClick={()=>this.setState({record:null,showPlayDetails:false})}>
                        Regresar
                      </Button>,
                    ]}
                  >
                    {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}

                    <p><FileTextOutlined />Título: {this.state.record.title}</p>
                      
                    <p><QrcodeOutlined />Código: {this.state.record.code} </p>
                    <p><CalendarOutlined />Fecha: {this.state.record.date} </p>

                    <p><TagsOutlined />Género:{this.state.record.category} </p>
                    
                    <p><AuditOutlined />Seudónimo: {this.state.record.pseudo} </p>
                    <p> <CheckOutlined />Calificada: {this.state.record.qualified == undefined ? "Sin Determinar":(this.state.record.qualified ? "Calificada":"Descalificada")}</p>
                    <p><StarOutlined />Preseleccionada: {this.state.record.preselected == undefined ? "Sin Determinar":(this.state.record.preselected ? "Preseleccionada":"No Preseleccionada")}</p>
                  </Modal>
                }
              </Content>
            </Layout>
          </ConfigProvider>
      </div>
      <Foot admin={true}/>
    </div>
    );
  }
}
export default AdminLogs;


